<template>
    <div ref="loader" class="mt-2">
        <b-container class="container-lg">
            <b-row class="p-0 pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-chevron-left" @click="goBack"></i> <i class="fa-solid fa-aw"></i>
                        {{ $t('Slas') }}
                    </h5>
                </b-col>
                <b-col class="text-end">
                    <button class="btn btn-light btn-sm" type="button" @click="refreshData">
                        <i :class="{'fa-spin': loading}"
                           class="fa-solid fa-arrows-rotate"></i>
                    </button>
                </b-col>
            </b-row>
            <b-list-group class="mt-2">
                <b-list-group-item>
                    <div class="row">
                        <div class="col">
                            <b-button v-b-toggle.filter class="m-0 w-100" variant="primary">
                                <i class="fa-solid fa-filter"></i>
                                {{ $t('Filter') }}
                            </b-button>
                        </div>
                    </div>
                    <b-collapse id="filter">

                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="name" :placeholder="$t('name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="description" :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="mt-2">
                            <b-button
                                class="w-100"
                                variant="outline-danger"
                                v-on:click="allFilter">{{ $t('filter.reset-filter') }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>
            <b-list-group
                v-for="sla in slas"
                v-bind:key="sla.id"
                class="mt-2">
                <b-list-group-item>
                    <div v-if="permissions.slamodule?.slas.viewdetails">
                        <router-link
                            :to="{name: 'slasDetails', params: {id: sla.id}}"
                            class="link-underline link-underline-opacity-0">
                            {{ sla.name }}
                        </router-link>
                    </div>
                    <div v-else>
                        <b>{{ sla.name }}</b>
                    </div>

                    <b-row v-if="sla.description" class="mt-2">
                        <small>{{ sla.description }}</small>
                    </b-row>
                    <div class="d-flex w-100 justify-content-between mt-2">
                        <div>
                            <div>
                                <small>
                                    <b> {{ $t('Evaluation interval') }} </b>
                                </small>
                            </div>
                            <div class="text-center">
                                <small>
                                    {{ sla.evaluation_interval }}
                                </small>
                            </div>
                        </div>

                        <div>
                            <div>
                                <small>
                                    <b> {{ $t('Time period') }} </b>
                                </small>
                            </div>
                            <div class="text-center">
                                <small>
                                    {{ sla.timeperiod.name }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex w-100 justify-content-between mt-2">
                        <div>
                            <div>
                                <small><b>{{ $t('Thresholds') }}</b></small>
                            </div>
                            <div v-if="sla.warning_threshold">
                                <span class="icon badge text-warning border border-warning">
                                    <i class="fa-solid fa-less-than"></i> {{ sla.warning_threshold }} %
                                </span>
                            </div>
                            <div v-if="sla.minimal_availability">
                                <span class="icon badge text-danger border border-danger">
                                    <i class="fa-solid fa-less-than"></i> {{ sla.minimal_availability }} %
                                </span>
                            </div>
                        </div>

                        <div>
                            <div>
                                <small><b>{{ $t('Achieved') }}</b></small>
                            </div>
                            <div class="text-center">
                                <span v-if="sla.status_percent !== null"
                                      :class="{'text-success': sla.fulfill, 'text-danger': !sla.fulfill}">
                                    {{ sla.status_percent }}%
                                </span>
                                <span v-if="sla.status_percent === null" class="text-center">
                                    <i class="fa-solid fa-minus text-primary"></i>
                                </span>
                            </div>
                        </div>

                        <div>
                            <div>
                                <small><b>{{ $t('Status') }}</b></small>
                            </div>
                            <div v-if="sla.status_percent !== null" class="text-center">
                                <span v-if="sla.fulfill" class="badge text-success border border-success">
                                    {{ $t('PASSED') }}
                                </span>
                                <span v-if="!sla.fulfill" class="badge text-danger border border-danger">
                                    {{ $t('FAILED') }}
                                </span>
                            </div>
                            <div v-if="sla.status_percent === null" class="text-center">
                                <span class="w-100 text-center">
                                    <i class="fa-solid fa-minus text-primary"></i>
                                </span>
                            </div>
                        </div>

                    </div>

                </b-list-group-item>
            </b-list-group>

            <b-list-group class="mt-3">
                <div v-if="slas.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">
                        <vue-awesome-paginate
                            v-model="paging.page"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            :on-click="getIndex"
                            :total-items="paging.count"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="slas.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>

        </b-container>
    </div>

</template>
<script>
import { debounce } from "../../helpers";
import { useToast } from "vue-toastification";
import { VueAwesomePaginate } from "vue-awesome-paginate";
import { BListGroup, BListGroupItem } from 'bootstrap-vue-next';

export default {
    name: "SlasIndex",
    components: {BListGroupItem, BListGroup, VueAwesomePaginate},
    data() {
        return {
            loading: false,
            requestStatus: false,
            listFilter: {
                filter: {
                    id: [],
                    name: '',
                    description: ""
                }
            },
            slas: [],
            paging: {
                page: 1,
                pageCount: 1
            },
            name: '',
            description: '',
            permissions: {}
        }
    },
    mounted() {
        this.permissions = this.$store.state.permissions;
        this.getIndex();
    },
    methods: {
        pushTo: function(name) {
            this.$router.push({name: name});
        },


        getIndex: function(page = 1) {
            this.error = false;
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/slas/index.json', {
                    filter: this.listFilter,
                    page: page
                }, {}
            ).then(response => {

                this.slas = response.data.slas.slas ?? [];
                this.permissions = response.data.permissions;
                this.paging = response.data.slas.paging;
                this.ready = true;
            })
                .catch(error => {
                    this.error = true;
                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },

        allFilter: function() {
            this.resetFilter();
            this.getIndex();
        },
        resetFilter: function() {
            this.name = null;
            this.description = null;

            this.listFilter = {
                filter: {
                    id: [],
                    name: '',
                    description: ""
                }
            };
        },
        refreshData: function() {
            this.resetFilter();
            this.getIndex();
        },
        goBack: function() {
            this.$router.back();
        }
    },
    watch: {
        name: debounce(function(newValue) {
            if(newValue != null) {
                this.listFilter.filter.name = newValue;
                this.getIndex();
            }
        }, 700),
        description: debounce(function(newValue) {
            if(newValue != null) {
                this.listFilter.filter.description = newValue;
                this.getIndex();
            }
        }, 700)
    }

}
</script>

<style scoped>

</style>
